import React, { useState } from 'react';
import { streetlearnApi } from '../api';
import { showToast } from '../../components/toast';

const GrantModal = ({ show, onHide, learner, onSuccess }) => {
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!note.trim()) {
      showToast.error('Please enter a note explaining why access is being granted');
      return;
    }

    try {
      setLoading(true);
      await streetlearnApi.grantEntitlement(learner.id, { note: note.trim() });
      showToast.success(`Lifetime access granted to ${learner.name || learner.phone}`);
      setNote('');
      onHide();
      if (onSuccess) onSuccess();
    } catch (err) {
      showToast.error(err.response?.data?.message || 'Failed to grant entitlement');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal show d-block"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header d-flex justify-content-between align-items-center">
              <h4 className="modal-title font-bold m-0">Grant Lifetime Access</h4>
              <button
                type="button"
                className="close"
                style={{ border: 'none', background: 'transparent', fontSize: '24px', lineHeight: '1', cursor: 'pointer', padding: '0 5px' }}
                onClick={onHide}
              >
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="text-muted mb-3">
                Granting complimentary lifetime access to{' '}
                <strong>
                  {learner?.name ? `${learner.name} (${learner.phone})` : learner?.phone}
                </strong>
                . This will immediately unlock all 16 levels and 147 lessons.
              </p>
              <div className="form-group mb-3">
                <label className="font-semibold text-sm">
                  Reason / Audit Note <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="e.g. Complimentary access for webinar participant / VIP client"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  required
                />
                <span className="text-muted small">
                  This note will be recorded permanently in the audit trail.
                </span>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={onHide}
                disabled={loading}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-success btn-sm" disabled={loading}>
                {loading ? 'Granting...' : 'Confirm & Grant Access'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GrantModal;
